<script setup>

import LoadingDots from "@/components/elements/waiter/LoadingDots.vue";
const props = defineProps(['alerts'])
</script>

<template>
    <div class="alert-label" v-if="alerts">
        <span
            v-for="alert in alerts"
        >
            {{alert}}
        </span>
    </div>
</template>

<style scoped lang="scss">
.alert-label{
    //margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    span{
        margin: 2px;
    }
}
</style>
